import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchHousekeepingServiceTypes,
  createHousekeepingServiceType,
  updateHousekeepingServiceType,
  deleteHousekeepingServiceType,
  type ListHousekeepingServiceTypesQuery,
  type CreateHousekeepingServiceTypePayload,
  type UpdateHousekeepingServiceTypePayload,
} from '@/services/api/housekeepingServiceTypes.api';

const KEY = 'housekeeping-service-types';

export function useHousekeepingServiceTypes(
  query: ListHousekeepingServiceTypesQuery,
  enabled = true,
) {
  return useQuery({
    queryKey: [KEY, query],
    queryFn: () => fetchHousekeepingServiceTypes(query),
    staleTime: 30_000,
    enabled: enabled && !!query.propertyId,
  });
}

export function useCreateHousekeepingServiceType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateHousekeepingServiceTypePayload) =>
      createHousekeepingServiceType(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEY] });
    },
  });
}

export function useUpdateHousekeepingServiceType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: UpdateHousekeepingServiceTypePayload;
    }) => updateHousekeepingServiceType(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEY] });
    },
  });
}

export function useDeleteHousekeepingServiceType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteHousekeepingServiceType(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEY] });
    },
  });
}
